import React from 'react';
import * as SettingsUI from '../SettingsUI';
import ReportSettingsForm from './ReportSettingsForm';

const ReportSettings = () => {
  return (
    <SettingsUI.SettingsSection>
      <SettingsUI.Title>Chart Settings</SettingsUI.Title>
      <ReportSettingsForm />
    </SettingsUI.SettingsSection>
  );
};

export default ReportSettings;
